var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DebugComponentWrapper',[_c('BBadge',{staticClass:"debug-instance-badge",attrs:{"pill":"","title":"Hide this by pressing 'ctrl + alt + b'","variant":_vm.variant}},[_vm._v(" "+_vm._s(_vm.instance.toUpperCase())+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }